import { forwardRef, type LabelHTMLAttributes } from 'react';

import { cn } from '@/shared/utils/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  /** Visually marks the field as required without breaking AT semantics. */
  required?: boolean;
}

export const Label = forwardRef<HTMLLabelElement, LabelProps>(
  ({ className, required, children, ...rest }, ref) => (
    <label ref={ref} className={cn('text-sm font-medium text-fg', className)} {...rest}>
      {children}
      {required ? (
        <span className="ml-0.5 text-danger-strong" aria-hidden="true">
          *
        </span>
      ) : null}
    </label>
  ),
);

Label.displayName = 'Label';
